'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { Button } from '@src/components/Button/Button';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNav } from '@src/components/TopNavV3/TopNavContext';
import { TopNavSubMenuTileSlider } from '@src/components/TopNavV3/TopNavMobile/TopNavSubMenuTileSlider';
import type { TopNavSubItem } from '@src/components/TopNavV3/TopNavProps';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
export const TopNavMobileSubMenu = () => {
  const $ = _c(27);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    expandedMenu,
    setMobileSubExpanded,
    setExpanded
  } = useTopNav();
  let t0;
  if ($[0] !== expandedMenu?.title || $[1] !== setMobileSubExpanded) {
    t0 = () => <div className="flex h-14 items-center border-b border-white/10 p-4"><button onClick={() => {
        setMobileSubExpanded(false);
      }} className="flex items-center gap-2"><ChevronLeftIcon className="size-5 text-bodi-accent-bright-500" /><p className="font-lateral text-body-lg">{expandedMenu?.title}</p></button></div>;
    $[0] = expandedMenu?.title;
    $[1] = setMobileSubExpanded;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const renderTitle = t0;
  let t1;
  if ($[3] !== expandedMenu?.ctaMobile?.href || $[4] !== expandedMenu?.ctaMobile?.newTab || $[5] !== expandedMenu?.ctaMobile?.title || $[6] !== expandedMenu?.hasCtaMobile || $[7] !== setExpanded || $[8] !== trackSelectNavCta) {
    t1 = () => {
      const content = <Button className="w-full" size="medium">{expandedMenu?.ctaMobile?.title}</Button>;
      return expandedMenu?.hasCtaMobile && expandedMenu?.ctaMobile?.title && <div className="fixed bottom-0 left-0 w-screen border-t border-bodi-gray-dark bg-bodi-black-text px-4 py-5"><div className="font-medium text-bodi-accent-bright-500">{expandedMenu?.ctaMobile?.href ? <LocalizedLink data-testid="menu-featured-item-mobile" onClick={() => {
            trackSelectNavCta({
              "cta url": expandedMenu?.ctaMobile?.href
            });
            setExpanded(false);
          }} href={expandedMenu?.ctaMobile?.href ?? ""} rel={expandedMenu?.ctaMobile?.newTab ? "noopener noreferrer" : ""} target={expandedMenu?.ctaMobile?.newTab ? "_blank" : "_self"}>{content}</LocalizedLink> : <div>{content}</div>}</div></div>;
    };
    $[3] = expandedMenu?.ctaMobile?.href;
    $[4] = expandedMenu?.ctaMobile?.newTab;
    $[5] = expandedMenu?.ctaMobile?.title;
    $[6] = expandedMenu?.hasCtaMobile;
    $[7] = setExpanded;
    $[8] = trackSelectNavCta;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const renderCtaMobile = t1;
  let t2;
  if ($[10] !== setExpanded || $[11] !== trackSelectNavCta) {
    t2 = (item, itemIdx) => <div className={cn("border-t border-white/10 px-4 py-6", {
      "border-t-0": itemIdx === 0
    })}><div className="text-heading-5 mb-4">{item.href ? <LocalizedLink className="inline-block hover:underline" data-testid={`sub-menu-${itemIdx}`} onClick={() => {
          trackSelectNavCta({
            "cta url": item?.href
          });
          setExpanded(false);
        }} href={item?.href} key={item?.title} rel={item?.newTab ? "noopener noreferrer" : ""} target={item?.newTab ? "_blank" : "_self"}>{item.title}</LocalizedLink> : <div>{item.title}</div>}</div><div className="flex flex-col">{item.links?.filter(_temp).map((subItem_0, subItemIdx) => <LocalizedLink className="flex items-center gap-1 p-2 text-body-lg font-medium text-bodi-gray-butters hover:underline" data-testid={`sub-menu-${subItemIdx}`} onClick={() => {
          trackSelectNavCta({
            "cta url": subItem_0?.href
          });
          setExpanded(false);
        }} href={subItem_0?.href ?? ""} key={subItem_0?.title} rel={subItem_0?.newTab ? "noopener noreferrer" : ""} target={subItem_0?.newTab ? "_blank" : "_self"}><div>{subItem_0.title}</div>{subItem_0.stamp && <>{"-"}<span className="text-body-sm font-medium text-bodi-accent-bright-500">{subItem_0.stamp}</span></>}</LocalizedLink>)}</div></div>;
    $[10] = setExpanded;
    $[11] = trackSelectNavCta;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const renderSubItem = t2;
  let t3;
  if ($[13] !== renderTitle) {
    t3 = renderTitle();
    $[13] = renderTitle;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== expandedMenu?.subItems || $[16] !== renderSubItem) {
    t4 = expandedMenu?.subItems?.filter(_temp2).map((item_1, itemIdx_0) => renderSubItem(item_1, itemIdx_0));
    $[15] = expandedMenu?.subItems;
    $[16] = renderSubItem;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TopNavSubMenuTileSlider />;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== renderCtaMobile) {
    t6 = renderCtaMobile();
    $[19] = renderCtaMobile;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t4 || $[22] !== t6) {
    t7 = <div className="relative flex flex-col">{t4}{t5}{t6}</div>;
    $[21] = t4;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t3 || $[25] !== t7) {
    t8 = <div className="relative h-[calc(100%-85px)] overflow-y-scroll">{t3}{t7}</div>;
    $[24] = t3;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
};
function _temp(subItem) {
  return Boolean(subItem.title);
}
function _temp2(item_0) {
  return Boolean(item_0.title);
}